module.exports = __webpack_public_path__ + "static/img/patuki-case-vena.dbc3bb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patuki-case-vena.jpg
// module id = VGVK
// module chunks = 0